import { CascadiaLayoutProps, withCascadiaLayoutProps } from "@certn/forms";
import { RenderError } from "@certn/forms/src/components/helpers/RenderError";
import { BaseLayout } from "@certn/forms/src/layouts/BaseLayout";
import { BaseLayoutContent } from "@certn/forms/src/layouts/BaseLayoutContent";
import { hasLabel } from "@certn/forms/src/utils";
import { css } from "@emotion/css";
import { isBooleanControl, rankWith } from "@jsonforms/core";
import { CustomQuestionnaireControlRenderer } from "../controls/custom-questionnaire";
import { CustomQuestionnaireLayoutContext } from "./CustomQuestionnaireLayoutContext";
import { useApplicantAPI } from "@certn/api";
import { useApplicationFormContext } from "../ApplicationFormContext";
import { Loader } from "@certn/cascadia-react";

function CustomQuestionnaireLayout(props: CascadiaLayoutProps) {
  const { uischema } = props;
  const { caseId } = useApplicationFormContext();

  const { data, isLoading, error } = useApplicantAPI(
    `/api/internal/applicant/case/${caseId}/custom-questionnaire-templates/`
  );

  if (!hasLabel(uischema)) {
    return <RenderError>Invalid Category</RenderError>;
  }
  if (isLoading) {
    return <Loader height="500px" />;
  }

  return (
    <BaseLayout {...props} className={styles.layout}>
      <CustomQuestionnaireLayoutContext.Provider
        value={{
          sectionLabel: props.label,
          subLabel: props.options?.subLabel,
          templateData: data,
          apiError: error,
        }}
      >
        <BaseLayoutContent
          renderers={[
            {
              tester: rankWith(1, isBooleanControl),
              renderer: CustomQuestionnaireControlRenderer,
            },
          ]}
        />
      </CustomQuestionnaireLayoutContext.Provider>
    </BaseLayout>
  );
}

CustomQuestionnaireLayout.displayName = "CustomQuestionnaireLayout";

const styles = {
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
};

export const CustomQuestionnaireLayoutRenderer = withCascadiaLayoutProps(
  CustomQuestionnaireLayout
);
